import getGlobalBySource from './get-global-by-source';

export default {
  getGlobalBySource,
};
